<template>
  <vs-popup class="create-new-crm-subejct" id="popup"
    :title="isCreateMode ? 'ADD COMPOSITION OPTION' : 'UPDATE COMPOSITION OPTION'" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-crm-subejct-popup" @submit.prevent="handleSubmit(onClickSubmitForm)" autocomplete="off">

          <span class="font-bold">*You can include a <span class="text-xl text-primary">%</span> symbol in option
            name field as a placeholder for a value that will be filled in later. <br> <br>
            eg: <span class="italic">" Carrier: MCT Oil <span class="text-primary">%</span> "</span> will become <span class="italic">" Carrier: MCT Oil <span class="text-primary">(15)</span> "</span>
          </span>
          <div class="mb-3 mt-4 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Option Name</small>
                <vs-input v-model="form.name" name="name" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-input v-model="form.description" name="description" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const FormulationRepository = RepositoryFactory.get('formulations');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      name: '',
      description: ''
    },
    isCreateMode: true
  }
}

export default {
  name: 'AddNewFormulationCompositionPopup',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchCrmSubjectDetails()
        } else {
          this.isCreateMode = true
        }
      } catch (error) {

      }
    },
    async fetchCrmSubjectDetails() {
      await this.$vs.loading({
        container: '#create-crm-subejct-popup',
        scale: 0.45
      })
      try {
        const { data } = (await FormulationRepository.getCompositionDetails(this.id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-crm-subejct-popup > .con-vs-loading')
    },
    async onClickSubmitForm() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-crm-subejct-popup',
        scale: 0.45
      })
      try {
        if (this.isCreateMode) {
          await FormulationRepository.createComposition(this.form);
          this.showSuccessMessage('Composition added!');
        } else {
          await FormulationRepository.updateComposition(this.id, this.form);
          this.showSuccessMessage('Composition updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-crm-subejct-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-crm-subejct-popup > .con-vs-loading')
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.create-new-crm-subejct>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}
</style>
